/**
 * 對齊 docs/02-資料字典.md：原 customer.phone1~3 / fax1~3 / mobile 正規化後的類型。
 */
export const PhoneType = {
  PHONE: 'PHONE',
  MOBILE: 'MOBILE',
  FAX: 'FAX',
} as const;

export type PhoneType = (typeof PhoneType)[keyof typeof PhoneType];
